export const socialMediaLinks = [
    { Instagram: "https://www.instagram.com/_dtan13_/" },
    { Telegram: "https://telegram.me/dtan13" },
    { Gitlab: "https://gitlab.com/_dtan13_/" },
    { Github: "https://github.com/dtan13" },
    { Linkedin: "https://linkedin.com/in/dtan13/" },
    { Twitter: "https://twitter.com/_DTan13_" }
];

export const siteData = {
    name: "(Dhananjay Tanpure)",
    githubUsername: "DTan13",
    ProjectLinks: [
        { Front: "https://github.com/DTan13/DTan13.github.io.git" },
        { Back: "https://github.com/DTan13/DTan13.github.io.api.git" }
    ]
};

export const eventList = {
    create: 'CreateEvent',
    commitComment: 'CommitCommentEvent',
    delete: 'DeleteEvent',
    fork: 'ForkEvent',
    wiki: 'GollumEvent',
    issueComment: 'IssueCommentEvent',
    issues: 'IssuesEvent',
    member: 'MemberEvent',
    public: 'PublicEvent',
    pullreq: 'PullRequestEvent',
    reviewComment: 'PullRequestReviewCommentEvent',
    push: 'PushEvent',
    release: 'ReleaseEvent',
    sponsor: 'SponsorshipEvent',
    watch: 'WatchEvent',
    prReview: 'PullRequestReviewEvent'
};